module.exports = __webpack_public_path__ + "img/temb2.02af525b.png";